import { DEFAULT_EVENT_TICKER } from '../defaults';
import { EVENT_REQUESTS } from '../dataSource';
import type { WidgetSchema } from '../types';

export const watchlist: WidgetSchema = {
    meta: {
        id: 'watchlist',
        category: 'watchlists',
        categoryTitle: 'Watchlists',
        title: 'Watchlist',
        description: 'A compact, ordered list of selected markets for an event.',
        status: 'live',
    },
    fields: [
        {
            kind: 'event-search',
            key: 'eventTicker',
            label: 'Event',
            defaultValue: DEFAULT_EVENT_TICKER,
            allowManualTicker: true,
        },
        {
            kind: 'market-select',
            key: 'marketIds',
            label: 'Markets (drag to reorder)',
            mode: 'orderable',
            min: 1,
            max: 5,
            autoSelectTopN: 2,
            defaultValue: [],
        },
        {
            kind: 'utm',
            key: 'utm',
            label: 'Marketing (UTM)',
            defaultValue: { utmSource: '', utmCampaign: '', promoCode: '' },
        },
        { kind: 'boolean', key: 'showBorder', label: 'Border', defaultValue: false },
        { kind: 'boolean', key: 'rounded', label: 'Rounded corners', defaultValue: false },
    ],
    preview: { kind: 'event-loader' },
    embed: { kind: 'event-loader', fixed: { widgetSize: 'medium', variant: 'a' } },
    dataSource: {
        summary: 'The watchlist lists markets from a single event, all of which come back in one call.',
        requests: EVENT_REQUESTS,
    },
};
